import request from "@/utils/request";
import Qs from "qs";

// 获取设施列表
export function getFacilityTypeList(data) {
  return request({
    url: "/common/get_facility_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取设备类型列表
export function getEquipmentTypeList(data) {
  return request({
    url: "/common/get_facility_equipment_type_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取设备列表
export function getEquipmentList(data) {
  return request({
    url: "/common/get_facility_equipment_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 设施列表
export function facilityList(data) {
  return request({
    url: "/facility/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加设施
export function addFacility(data) {
  return request({
    url: "/facility/add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑设施
export function editFacility(data) {
  return request({
    url: "/facility/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 查看设施
export function seeFacility(data) {
  return request({
    url: "/facility/info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除设施
export function delFacility(data) {
  return request({
    url: "/facility/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 设备类型列表
export function TypeList(data) {
  return request({
    url: "/equipment/type_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加设备类型
export function addType(data) {
  return request({
    url: "/equipment/type_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑设备类型
export function editType(data) {
  return request({
    url: "/equipment/type_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 查看设备类型
export function seeType(data) {
  return request({
    url: "/equipment/type_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除设备类型
export function delType(data) {
  return request({
    url: "/equipment/type_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 设备巡检任务列表
export function patrolEquipmentLists(data) {
  return request({
    url: "/patrol/equipment_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加设备巡检任务
export function addEquipmentPatrol(data) {
  return request({
    url: "/patrol/equipment_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑设备巡检任务
export function editEquipmentPatrol(data) {
  return request({
    url: "/patrol/equipment_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 设备巡检任务详情
export function seeEquipmentPatrol(data) {
  return request({
    url: "/patrol/equipment_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除设备巡检任务
export function delEquipmentPatrol(data) {
  return request({
    url: "/patrol/equipment_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 批量启用设备巡检任务
export function enableEquipmentPatrol(data) {
  return request({
    url: "/patrol/equipment_enable",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 批量停用设备巡检任务
export function disableEquipmentPatrol(data) {
  return request({
    url: "/patrol/equipment_disable",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 复制设备巡检任务
export function copyEquipmentPatrol(data) {
  return request({
    url: "/patrol/equipment_copy",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 设备列表
export function equipmentLists(data) {
  return request({
    url: "/equipment/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加设备
export function addEquipment(data) {
  return request({
    url: "/equipment/add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑设备巡检任务
export function editEquipment(data) {
  return request({
    url: "/equipment/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 查看设备
export function seeEquipment(data) {
  return request({
    url: "/equipment/info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除设备
export function delEquipment(data) {
  return request({
    url: "/equipment/del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 导入设备
export function importEquipment(data) {
  return request({
    url: "/equipment/import",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 导出设备
export function exportEquipment(data) {
  return request({
    url: "/equipment/export",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}

// 下载设备导入模板
export function templatetEquipment(data) {
  return request({
    url: "/equipment/template",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 设备巡检记录-列表
export function equipmentTaskDayLists(data) {
  return request({
    url: "/patrol/equipment_task_day_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 设备巡检记录-任务进度
export function equipmentTaskDayProgress(data) {
  return request({
    url: "/patrol/equipment_task_day_progress",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 设备巡检记录-任务详情
export function equipmentTaskDayDetail(data) {
  return request({
    url: "/patrol/equipment_task_day_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 关闭当日设备巡检任务-任务详情
export function task_day_close_equipment(data) {
  return request({
    url: "/patrol/task_day_close_equipment",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 开启当日设备巡检任务-任务详情
export function task_day_open_equipment(data) {
  return request({
    url: "/patrol/task_day_open_equipment",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 设备巡检记录导出
export function task_day_equipment_lists_export(data) {
  return request({
    url: "/patrol/task_day_equipment_lists_export",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}

// 创优-手动完成设备巡检任务
export function equipment_task_day_manual_work(data) {
  return request({
    url: "/patrol/equipment_task_day_manual_work",
    method: "post",
    data: Qs.stringify(data)
  });
}